import React from 'react'
import MenuItem from '@material-ui/core/MenuItem'
import Box from '@material-ui/core/Box'
import { useTranslation } from 'react-i18next'
import EDialog from '../../mobile/themes/components/EDialog'

const SignOutButton = ({ name, onConfirm, ...props }) => {
  const { t } = useTranslation()

  const handleConfirm = async () => {
    onConfirm && onConfirm()
  }

  return (
    <>
      {/* <Button variant="text" color="primary" {...props} onClick={handleOpen}>
        {name}
      </Button> */}
      <EDialog
        title={t('are_you_sure.sign_out')}
        trigger={
          <MenuItem className={props.className}>
            <Box color={props.color || 'primary.main'} fontWeight={600}>
              {t('common.sign_out')}
            </Box>
          </MenuItem>
        }
        onConfirm={handleConfirm}
      />
    </>
  )
}

export default SignOutButton
